import { Link } from '@mui/material'
import { palette } from '../../ui/theme/tokens.js'

/**
 * « Prix d'achat manquant sur N lignes vendues » — un LIEN, pas une remarque.
 *
 * ⭐ L'avertissement disait que le bénéfice était faux sans dire quoi faire.
 * Il mène désormais au catalogue réduit aux produits sans prix d'achat : c'est
 * leur fiche qu'il faut compléter, et le bénéfice se recalcule aussitôt.
 *
 * ⚠️ Au-dessus du bouton de la carte (`zIndex: 2`) : sans cela, le clic
 * partirait vers la liste des ventes, que la carte ouvre sur toute sa surface.
 *
 * ⚠️ Ambre FONCÉ en clair : l'ambre du thème, sur fond blanc, n'offre que
 * 2 : 1 de contraste — illisible pour un texte, a fortiori pour un lien.
 */
export function LienPrixAchat({
  nombre,
  onClick,
}: {
  nombre: number
  onClick: () => void
}): JSX.Element {
  return (
    <Link
      component="button"
      type="button"
      variant="caption"
      onClick={(e) => {
        e.stopPropagation()
        onClick()
      }}
      sx={{
        position: 'relative',
        zIndex: 2,
        display: 'block',
        textAlign: 'left',
        color: (t) => (t.palette.mode === 'dark' ? palette.warning[500] : palette.warning[700]),
        textDecorationColor: 'currentColor',
      }}
    >
      Prix d’achat manquant sur {nombre} ligne{nombre > 1 ? 's' : ''} vendue{nombre > 1 ? 's' : ''} :
      bénéfice surestimé. Compléter les prix →
    </Link>
  )
}
